import { Helmet } from "react-helmet-async";

const SITE_URL = "https://p2amarketing.com.br";
const DEFAULT_IMAGE = `${SITE_URL}/wp-content/uploads/2026/03/Logo-branca-Sem-fundo.png`;

interface SeoProps {
  title: string;
  description: string;
  path: string;
  image?: string;
  type?: "website" | "article";
  noindex?: boolean;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

export function Seo({
  title,
  description,
  path,
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
  jsonLd,
}: SeoProps) {
  const url = `${SITE_URL}${path}`;
  const schema = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {schema.map((item, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "P2A Marketing & Branding",
  url: SITE_URL,
  logo: DEFAULT_IMAGE,
  image: DEFAULT_IMAGE,
  description:
    "Consultoria estratégica e operação especializada em marketing, branding e automações com I.A. para infoprodutos e negócios físicos.",
  telephone: "+5524993144981",
  email: "contato@p2amarketing.com.br",
  areaServed: "BR",
  sameAs: [
    "https://www.instagram.com/p2amarketing/",
    "https://www.facebook.com/profile.php?id=100084326275760",
    "https://www.tiktok.com/@pri_cboaventura",
  ],
};

export { SITE_URL };
